<template>
    <popup
        class="datetime-picker"
        v-model="isShow"
        position="bottom">
        <datetime-picker
            v-model="value"
            :type="type"
            :min-date="minDate"
            :max-date="maxDate"
            :swipe-duration="300"
            @confirm="confirm"
            @cancel="close">
        </datetime-picker>
    </popup>
</template>

<script>
    import dayjs from 'dayjs'
    import { Popup, DatetimePicker } from 'vant'
    import { MESSAGE_NAME } from '@/constants/message'
    import { sendMessage } from '@/utils/message_send'

    export default {
        name: 'DateTimePicker',
        components: {
            Popup,
            DatetimePicker
        },
        props: {
            name: {
                type: String,
                required: true
            },
            type: {
                type: String,
                default: 'date',
                required: false,
                validator (value) {
                    return ['date', 'time', 'year-month'].includes(value)
                }
            },
            minDate: {
                type: Date,
                required: false
            },
            maxDate: {
                type: Date,
                required: false
            },
            format: {
                type: String,
                required: false,
                default: 'YYYY-MM-DD'
            }
        },
        data () {
            return {
                isShow: false,
                value: new Date()
            }
        },
        methods: {
            confirm (value) {
                this.close()
                sendMessage({
                    type: 'base',
                    detailType: MESSAGE_NAME.TEXT,
                    content: dayjs(value).format(this.format)
                })
                this.reset()
            },
            close () {
                this.isShow = false
            },
            reset () {
                this.value = new Date()
            }
        },
        created () {
            this.$eventBus.$on(`SHOW_${this.name}_PICKER`, () => {
                this.isShow = true
            })
        },
        beforeDestroy () {
            this.$eventBus.$off(`SHOW_${this.name}_PICKER`)
        }
    }
</script>
